/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IProductSpotlightData } from './product-spotlight.data';
import { IProductSpotlightProps } from './product-spotlight.props.autogenerated';
import { Button } from 'reactstrap';
interface Product {
    id: string;
    title: string;
    discount: string;
    price: string;
    imageUrl: string;
}

interface State {
    products: Product[];
}

export interface IProductSpotlightViewProps extends IProductSpotlightProps<IProductSpotlightData> {
    ProductSpotlight: React.ReactElement;
}

/**
 *
 * ProductSpotlight component
 * @extends {React.PureComponent<IProductSpotlightProps<IProductSpotlightData>>}
 */
class ProductSpotlight extends React.PureComponent<IProductSpotlightProps<IProductSpotlightData>, State> {
    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
    state: State = {
        products: [
            {
                id: '1',
                title: 'AmpCharge EV Charger 7kW Flash',
                discount: 'save $100',
                price: '$599',
                imageUrl: '/images/ev1.png'
            },
            {
                id: '2',
                title: 'AmpCharge EV Charger 7kW',
                discount: 'save $100',
                price: '$699',
                imageUrl: '/images/ev2.png'
            }
        ]
    };

    public render(): JSX.Element | null {
        const viewprops = {
            ...this.props,
            ProductSpotlight: this.getProductSpotlightData()
        };
        return this.props.renderView(viewprops) as React.ReactElement;
    }
    private getProductSpotlightData(): JSX.Element {
        const {
            productSportLightImage,
            productSportLightImageRight,
            productSportLightLeftTitle,
            productSportLightLeftLink,
            productSportLightLeftPrice,
            productSportLightRightTitle,
            productSportLightRightLink,
            productSportLightRightPrice
        } = this.props.config;
        console.log('productSportLightImage', productSportLightRightLink);
        return (
            <>
                {/* <div className='msv-showcase-container'>
                    <div className='msv-products-row'>
                        <div className='msv-product-column'>
                            <div className='msv-product-card'>
                                <div className='msv-charger-image'>
                                    <img src={productSportLightImage?.src} alt='EPC EV Charger 7kW Flash' className='msv-charger-photo' />
                                </div>
                                <div className='msv-product-info msv-product-info-left'>
                                    <div className='msv-price'>$699</div>
                                    <div className='msv-product-name'>EPC EV Charger</div>
                                    <div className='msv-product-spec'>7kW Flash</div>
                                    <button className='msv-shop-button'>SHOP NOW</button>
                                </div>
                            </div>
                        </div>

                        <div className='msv-product-column'>
                            <div className='msv-product-card'>
                                <div className='msv-charger-image'>
                                    <img src={productSportLightImage?.src} alt='EPC EV Charger 7kW Flash' className='msv-charger-photo' />
                                </div>
                                <div className='msv-product-info msv-product-info-right'>
                                    <div className='msv-price'>$799</div>
                                    <div className='msv-product-name'>EPC EV Charger</div>
                                    <div className='msv-product-spec'>7kW Price</div>
                                    <button className='msv-shop-button'>SHOP NOW</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}
                <div className='msv-showcase'>
                    <div className='msv-showcase__row'>
                        <div className='msv-showcase__column'>
                            <div className='msv-showcase__card'>
                                <div className='msv-showcase__image'>
                                    <img
                                        src={productSportLightImage?.src}
                                        alt={productSportLightImage?.altText}
                                        className='msv-showcase__image-photo'
                                    />
                                </div>
                                <div className='msv-showcase__info msv-showcase__info--left'>
                                    <div className='msv-showcase__price'>{productSportLightLeftPrice ?? '$699'}</div>
                                    <div className='msv-showcase__name'>
                                        {productSportLightLeftTitle ? productSportLightLeftTitle : 'EPC EV Charger 7kW Flash'}
                                    </div>
                                    <div className='msv-showcase__spec'></div>
                                    <Button
                                        className='msv-showcase__button'
                                        href={productSportLightLeftLink?.linkUrl.destinationUrl ?? ''}
                                        title={productSportLightLeftLink?.linkText ?? ''}
                                    >
                                        {productSportLightLeftLink?.linkText ?? 'SHOP NOW'}
                                    </Button>
                                </div>
                            </div>
                        </div>

                        <div className='msv-showcase__column'>
                            <div className='msv-showcase__card'>
                                <div className='msv-showcase__image'>
                                    <img
                                        src={productSportLightImageRight?.src ?? productSportLightImage?.src}
                                        alt={productSportLightImageRight?.altText}
                                        className='msv-showcase__image-photo'
                                    />
                                </div>
                                <div className='msv-showcase__info msv-showcase__info--right'>
                                    <div className='msv-showcase__price'>{productSportLightRightPrice ?? '$699'}</div>
                                    <div className='msv-showcase__name'>
                                        {productSportLightRightTitle ? productSportLightRightTitle : 'EPC EV Charger 7kW Flash'}
                                    </div>
                                    <div className='msv-showcase__spec'></div>

                                    <Button
                                        className='msv-showcase__button'
                                        href={productSportLightRightLink?.linkUrl.destinationUrl ?? ''}
                                        title={productSportLightRightLink?.linkText ?? ''}
                                    >
                                        {productSportLightRightLink?.linkText ?? 'SHOP NOW'}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default ProductSpotlight;
